/**
 * Opens and scrolls to the product "How to use" block when the URL
 * contains ?scroll=how-to-use. Other query params are ignored.
 * No-ops on every other product URL.
 *
 * New PDP: How to Use is a tab in [data-new-product-tabs], not an accordion.
 * Classic PDP: it is details.hdt-product-accordion__item.how-to-use.
 * Opening an hdt-accordion still goes through the summary click handler
 * in global.js. This file does not restyle either layout.
 */
(function () {
    var params = new URLSearchParams(window.location.search);
    if (params.get("scroll") !== "how-to-use") return;
  
    var HEADER_FALLBACK_OFFSET = 120;
    var OPEN_SETTLE_MS = 500;
    var POLL_MS = 300;
    var MAX_ATTEMPTS = 30;
  
    var completed = false;
    var scheduled = false;

    function normalizeLabel(text) {
      return (text || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9 ]/g, "")
        .replace(/\s+/g, " ")
        .trim();
    }

    function isHowToUseLabel(text) {
      return normalizeLabel(text) === "how to use";
    }

    function findHowToUseTab() {
      var marked = document.querySelector(
        '[data-new-product-tabs] [data-tab-trigger][data-scroll-target="how-to-use"]'
      );
      if (marked) return marked;

      var buttons = document.querySelectorAll("[data-new-product-tabs] [data-tab-trigger]");
      for (var i = 0; i < buttons.length; i++) {
        if (isHowToUseLabel(buttons[i].textContent)) return buttons[i];
      }
      return null;
    }

    function findHowToUseAccordion() {
      var marked = document.querySelector(
        "details.hdt-product-accordion__item.how-to-use, details.pdp-nested-accordion__item.how-to-use"
      );
      if (marked) return marked;

      var items = document.querySelectorAll(
        "details.hdt-product-accordion__item, details.pdp-nested-accordion__item"
      );
      for (var i = 0; i < items.length; i++) {
        var title = items[i].querySelector(
          ".hdt-product-accordion__text, .pdp-nested-accordion__title"
        );
        if (title && isHowToUseLabel(title.textContent)) return items[i];
      }
      return null;
    }

    function findTarget() {
      var tab = findHowToUseTab();
      if (tab) return { type: "tab", tab: tab };

      var accordion = findHowToUseAccordion();
      if (accordion) return { type: "accordion", el: accordion };

      return null;
    }

    function activateHowToUseTab(tab) {
      var root = tab.closest("[data-new-product-tabs]") || tab;
      var index = tab.getAttribute("data-tab-trigger");
      var tabs = root.querySelectorAll("[data-tab-trigger]");
      var panels = root.querySelectorAll("[data-tab-panel]");

      for (var i = 0; i < tabs.length; i++) {
        var isActive = tabs[i] === tab;
        tabs[i].classList.toggle("is-active", isActive);
        tabs[i].setAttribute("aria-selected", isActive ? "true" : "false");
      }

      for (var j = 0; j < panels.length; j++) {
        panels[j].hidden = panels[j].getAttribute("data-tab-panel") !== index;
      }

      var nav = tab.parentElement;
      if (nav && nav.scrollWidth > nav.clientWidth) {
        var left = tab.offsetLeft - (nav.clientWidth - tab.offsetWidth) / 2;
        nav.scrollLeft = left < 0 ? 0 : left;
      }

      return root;
    }

    function directSummary(details) {
      var children = details.children;
      for (var i = 0; i < children.length; i++) {
        if (children[i].tagName === "SUMMARY") return children[i];
      }
      return null;
    }

    function openDetails(details) {
      if (!details || details.tagName !== "DETAILS" || details.hasAttribute("open")) return;
      var summary = directSummary(details);
      if (summary) summary.click();
      else details.setAttribute("open", "");
    }

    function openAccordion(details) {
      var chain = [];
      var node = details.parentElement;
      while (node) {
        if (node.tagName === "DETAILS") chain.push(node);
        node = node.parentElement;
      }
      for (var i = chain.length - 1; i >= 0; i--) openDetails(chain[i]);
      openDetails(details);
    }
  
    function stickyCoverBottom() {
      var bottom = 0;
      var nodes = document.querySelectorAll(".hdt-section-header, hdt-sticky-header, .menu-full-with");
  
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var style = window.getComputedStyle(el);
        if (style.display === "none" || style.visibility === "hidden") continue;
  
        var rect = el.getBoundingClientRect();
        if (rect.height < 1 || rect.width < 1) continue;
        // Logo row plus the desktop nav. After scroll the nav is position:absolute
        // and hangs below the header box, so its own bottom has to be included.
        if (rect.bottom <= 0 || rect.top > 240) continue;
        if (rect.bottom > bottom) bottom = rect.bottom;
      }
  
      return Math.round(bottom);
    }
  
    function getHeaderOffset() {
      var cover = stickyCoverBottom();
      if (!cover) return HEADER_FALLBACK_OFFSET;
      // Clear the full sticky stack (logo row + nav) so the heading is not underneath it.
      return cover + 24;
    }
  
    function scrollToHowToUse(anchor) {
      if (completed || !anchor) return;
  
      function place(behavior) {
        var offset = getHeaderOffset();
        var rect = anchor.getBoundingClientRect();
        var targetPosition = (window.scrollY || window.pageYOffset || 0) + rect.top - offset;
        if (targetPosition < 0) targetPosition = 0;
  
        var current = window.scrollY || window.pageYOffset || 0;
        if (Math.abs(current - targetPosition) < 8) return;
  
        window.scrollTo({
          top: targetPosition,
          behavior: behavior,
        });
      }
  
      place("smooth");
  
      // scrolled-past-header pulls the nav out of flow. Recheck once that layout settles
      // so the "How to use" heading is not left under the sticky header.
      window.setTimeout(function () {
        if (completed) return;
        completed = true;
        place("auto");
      }, 700);
    }
  
    function openAndScrollToHowToUse() {
      if (completed || scheduled) return true;
  
      var target = findTarget();
      if (!target) return false;
  
      scheduled = true;
  
      var anchor = target.el;
      if (target.type === "tab") {
        anchor = activateHowToUseTab(target.tab);
      } else {
        openAccordion(target.el);
        anchor = directSummary(target.el) || target.el;
      }
  
      window.setTimeout(function () {
        scrollToHowToUse(anchor);
      }, OPEN_SETTLE_MS);
  
      return true;
    }
  
    function start() {
      if (openAndScrollToHowToUse()) return;
  
      var attempts = 0;
      var interval = window.setInterval(function () {
        attempts += 1;
        if (openAndScrollToHowToUse() || attempts >= MAX_ATTEMPTS) {
          window.clearInterval(interval);
        }
      }, POLL_MS);
    }
  
    function boot() {
      if (window.customElements && typeof customElements.whenDefined === "function") {
        var booted = false;
        var run = function () {
          if (booted) return;
          booted = true;
          start();
        };
  
        customElements.whenDefined("hdt-accordion").then(run);
        window.setTimeout(run, 2000);
        return;
      }
  
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", start);
      } else {
        start();
      }
    }
  
    boot();
  })();
  